__turbopack_context__.v({
  "active": "-r5dJW_active",
  "categoriesGrid": "-r5dJW_categoriesGrid",
  "categoryCard": "-r5dJW_categoryCard",
  "categoryCount": "-r5dJW_categoryCount",
  "categoryDescription": "-r5dJW_categoryDescription",
  "categoryIcon": "-r5dJW_categoryIcon",
  "categoryInfo": "-r5dJW_categoryInfo",
  "categoryName": "-r5dJW_categoryName",
  "clearButton": "-r5dJW_clearButton",
  "filterGroup": "-r5dJW_filterGroup",
  "filterLabel": "-r5dJW_filterLabel",
  "filterSelect": "-r5dJW_filterSelect",
  "filtersRow": "-r5dJW_filtersRow",
  "noResults": "-r5dJW_noResults",
  "noResultsIcon": "-r5dJW_noResultsIcon",
  "noResultsText": "-r5dJW_noResultsText",
  "noResultsTitle": "-r5dJW_noResultsTitle",
  "popularTags": "-r5dJW_popularTags",
  "resultsCount": "-r5dJW_resultsCount",
  "resultsHeader": "-r5dJW_resultsHeader",
  "searchActions": "-r5dJW_searchActions",
  "searchButton": "-r5dJW_searchButton",
  "searchContainer": "-r5dJW_searchContainer",
  "searchForm": "-r5dJW_searchForm",
  "searchIcon": "-r5dJW_searchIcon",
  "searchInput": "-r5dJW_searchInput",
  "searchInputGroup": "-r5dJW_searchInputGroup",
  "searchResults": "-r5dJW_searchResults",
  "searchSuggestions": "-r5dJW_searchSuggestions",
  "sortSelect": "-r5dJW_sortSelect",
  "suggestionItem": "-r5dJW_suggestionItem",
  "suggestionsList": "-r5dJW_suggestionsList",
  "suggestionsTitle": "-r5dJW_suggestionsTitle",
  "tagCount": "-r5dJW_tagCount",
  "tagItem": "-r5dJW_tagItem",
  "tagsList": "-r5dJW_tagsList",
  "tagsTitle": "-r5dJW_tagsTitle",
});
